//获取存粹的uri参数
function getUri_params() {
  var getUriParams = {};
  ///获取uri的参数
  var url = window.location.href;             //获取当前url
  var dz_url = url.split('#')[0];                //获取#/之前的字符串
  //获取?之后的参数字符串
  var get_wenhao_split_list = dz_url.split('?')
  var split_wenhao_after = get_wenhao_split_list[1];
  //如果存在
  if (split_wenhao_after) {
    //参数字符串分割为数组
    var split_deta_after = split_wenhao_after.split('&');
    if (split_deta_after) {
      for (var i = 0; i < split_deta_after.length; i++) {         //遍历数组，拿到json对象
        var key = split_deta_after[i].split('=')[0]
        var value = split_deta_after[i].split('=')[1]
        //获取等于号前后的：key=value
        getUriParams[key] = value
      }
    }
  }

  console.log("uri参数：")
  console.log(JSON.stringify(getUriParams))
  return getUriParams
}

/**
 * 获取param参数，app传递进来的
 * @returns {any}
 */
function getParam() {
  //获取的参数
  var getParam;


  //获取uri参数
  var getUriParams = getUri_params()
  //获取到了param
  var getParamString = decodeURIComponent(getUriParams["param"]);
  // alert("获取uri参数："+getParamString+","+isEmpty(getParamString))

  if(isEmpty(getParamString)){
    //先获取参数的获取字符串格式
    getParamString = localStorage.getItem('getParam')
    // alert("获取localStorage参数："+getParamString)
  }else{
    //存储数据
    localStorage.setItem('getParam', getParamString);
  }
  try{
    getParam = JSON.parse(getParamString)
  }catch (e) {
    getParam = JSON.parse("{}")
  }

  if(!getParam){
    getParam = JSON.parse("{}")
  }

  return getParam;
}

/**
 * 获取系统信息的方法，app传递进来的
 */
var getSystemInfo = function () {
  //要不去的参数jsonObject格式
  var getSystemParam;

  //获取uri参数
  var getUriParams = getUri_params()
  //获取到了param
  var getSystemParamString = decodeURIComponent(getUriParams["systemParam"]);
  // alert("获取uri参数："+getSystemParamString+","+isEmpty(getSystemParamString))

  //如果有问题再从存储中获取
  if(isEmpty(getSystemParamString)){
    //先获取参数的获取字符串格式
    getSystemParamString = localStorage.getItem('getSystemParam')
    // alert("获取local参数："+getSystemParamString)
  }else{
    //存储数据
    localStorage.setItem('getSystemParam', getSystemParamString);
  }


  try {
    getSystemParam = JSON.parse(getSystemParamString)
  }catch (e) {
    getSystemParam = JSON.parse("{}")
  }



  return getSystemParam;
}

/*获取随机数*/
function random_n(n) {
  let res = ''
  for (; res.length < n; res += Math.random().toString(36).substr(2).toUpperCase()) {
  }

  return res.substr(0, n)
}

/*用户信息 ---- end */

///全屏加载按钮,当前页面,注意：pageThis.$parent必须为App.vue,只有这个方法中有
function showLoadingBar_with_text(pageThis) {
  pageThis.$parent.showLoadingBar_with_text()
}

function hideLoadingBar(pageThis) {
  pageThis.$parent.hideLoadingBar()
}

/*获取系统信息  -----start*/
//判断数组中是否包含某字符串
Array.prototype.contains = function (needle) {
  for (i in this) {
    var getString = this[i]
    if (getString.indexOf(needle) > 0) {
      return i;
    }

  }
  return -1;
}


function isEmpty(obj){
  if(typeof obj == "undefined" || obj == "undefined" || obj == null || obj == ""){
    return true;
  }else{
    return false;
  }
}


//暴露出去的接口
export default {
  getUri_params:getUri_params,///获取url后面的参数

  getParam: getParam,///获取参数信息
  getSystemInfo: getSystemInfo,//获取系统信息

  //显示和隐藏加载框
  showLoadingBar_with_text: showLoadingBar_with_text,
  hideLoadingBar: hideLoadingBar,
}



// WEBPACK FOOTER //
// ./src/utils/C.js